// wcwb/frontend/src/components/EditEventModal.js
import { useState } from 'react';
import { S } from './styles';

const EMOJIS = ['🍽️','🫒','🍂','🌮','🍜','🎉','🥂','🫕','🍣','🥗','🌸','🧆'];

const TIMEZONES = [
  { group:'North America', zones:[
    { value:'America/St_Johns',    label:'Newfoundland (NST/NDT)' },
    { value:'America/Halifax',     label:'Atlantic (AST/ADT)' },
    { value:'America/Toronto',     label:'Eastern (EST/EDT)' },
    { value:'America/Chicago',     label:'Central (CST/CDT)' },
    { value:'America/Denver',      label:'Mountain (MST/MDT)' },
    { value:'America/Vancouver',   label:'Pacific (PST/PDT)' },
    { value:'America/Anchorage',   label:'Alaska (AKST/AKDT)' },
    { value:'Pacific/Honolulu',    label:'Hawaii (HST)' },
  ]},
  { group:'Europe', zones:[
    { value:'Europe/London',       label:'London (GMT/BST)' },
    { value:'Europe/Paris',        label:'Paris / Berlin (CET/CEST)' },
    { value:'Europe/Helsinki',     label:'Helsinki (EET/EEST)' },
    { value:'Europe/Moscow',       label:'Moscow (MSK)' },
  ]},
  { group:'Asia / Pacific', zones:[
    { value:'Asia/Dubai',          label:'Dubai (GST)' },
    { value:'Asia/Kolkata',        label:'India (IST)' },
    { value:'Asia/Singapore',      label:'Singapore (SGT)' },
    { value:'Asia/Tokyo',          label:'Tokyo (JST)' },
    { value:'Australia/Sydney',    label:'Sydney (AEST/AEDT)' },
    { value:'Pacific/Auckland',    label:'Auckland (NZST/NZDT)' },
  ]},
  { group:'Other', zones:[
    { value:'UTC',                 label:'UTC' },
    { value:'America/Sao_Paulo',   label:'São Paulo (BRT)' },
    { value:'Africa/Johannesburg', label:'Johannesburg (SAST)' },
  ]},
];

const inputStyle = {
  width:'100%', padding:'10px 13px', border:'1px solid #E5D9C8',
  borderRadius:10, fontFamily:'Jost,sans-serif', fontSize:14,
  color:'#2C1A0E', outline:'none', marginBottom:16, background:'white',
};

export default function EditEventModal({ event, onClose, onSave }) {
  const [form, setForm] = useState({
    title:    event.title    || '',
    date:     event.date     || '',
    time:     event.time     || '',
    address:  event.address  || '',
    theme:    event.theme    || '',
    emoji:    event.emoji    || '🍽️',
    timezone: event.timezone || 'America/Denver',
  });
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');

  async function handleSave() {
    setSaving(true); setError('');
    try {
      await onSave(form);
      onClose();
    } catch(e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(44,26,14,.55)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300, padding:16 }} onClick={onClose}>
      <div style={{ background:'white', borderRadius:24, width:'100%', maxWidth:540, maxHeight:'92vh', overflowY:'auto', padding:32 }} onClick={e => e.stopPropagation()}>

        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:24 }}>
          <div>
            <h3 style={{ fontFamily:'Cormorant Garamond,serif', fontSize:24 }}>Edit event</h3>
            <p style={{ fontSize:13, color:'#7A6555', marginTop:4 }}>Update the details for your dinner party</p>
          </div>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:22, cursor:'pointer', color:'#7A6555' }}>×</button>
        </div>

        {error && <div style={{ background:'#FFEBEE', color:'#B71C1C', padding:'10px 14px', borderRadius:8, fontSize:13, marginBottom:16 }}>{error}</div>}

        {/* Emoji picker */}
        <label style={S.label}>Party emoji</label>
        <div style={{ display:'flex', gap:6, flexWrap:'wrap', marginBottom:16 }}>
          {EMOJIS.map(e => (
            <button key={e} onClick={() => setForm(f => ({ ...f, emoji:e }))}
              style={{ fontSize:22, background:form.emoji===e?'#FAEEE8':'transparent', border:form.emoji===e?'2px solid #C4612A':'2px solid transparent', borderRadius:8, padding:'4px 8px', cursor:'pointer' }}>
              {e}
            </button>
          ))}
        </div>

        <label style={S.label}>Event name</label>
        <input style={inputStyle} placeholder="e.g. Midsummer Mediterranean Night"
          value={form.title} onChange={e => setForm(f => ({ ...f, title:e.target.value }))} />

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
          <div>
            <label style={S.label}>Date</label>
            <input type="date" style={inputStyle} value={form.date}
              onChange={e => setForm(f => ({ ...f, date:e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Time</label>
            <input style={inputStyle} value={form.time}
              onChange={e => setForm(f => ({ ...f, time:e.target.value }))} />
          </div>
        </div>

        <label style={S.label}>Timezone</label>
        <select style={inputStyle} value={form.timezone} onChange={e => setForm(f => ({ ...f, timezone:e.target.value }))}>
          {TIMEZONES.map(group => (
            <optgroup key={group.group} label={group.group}>
              {group.zones.map(tz => (
                <option key={tz.value} value={tz.value}>{tz.label}</option>
              ))}
            </optgroup>
          ))}
        </select>

        <label style={S.label}>Address</label>
        <input style={inputStyle} placeholder="Your address"
          value={form.address} onChange={e => setForm(f => ({ ...f, address:e.target.value }))} />

        <label style={S.label}>Theme & vibe</label>
        <textarea style={{ ...inputStyle, resize:'vertical', minHeight:72 }}
          placeholder="Describe the cuisine theme, dress code, atmosphere…"
          value={form.theme} onChange={e => setForm(f => ({ ...f, theme:e.target.value }))} />

        <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
          <button style={S.btnGhost} onClick={onClose}>Cancel</button>
          <button
            style={{ ...S.btnPrimary, opacity:(!form.title||!form.date||saving)?0.5:1 }}
            disabled={!form.title||!form.date||saving}
            onClick={handleSave}>
            {saving ? 'Saving…' : 'Save changes'}
          </button>
        </div>
      </div>
    </div>
  );
}
